import { BASE_URL } from "lib/utilities/globalConstants";
import { toast } from "react-toastify";

export const handleDownloadCandidateData = async (token, formId, receiverEmail, dashboardType) => {
    try {
        const response = await fetch(`${BASE_URL}admin/download-candidate-data`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
                formId,
                receiverEmail,
                dashboardType
            }),
        });

        if (!response.ok) {
            throw new Error("Failed to send Excel request");
        }

        const result = await response.json();
        
        toast.success("Candidate data has been emailed to your account successfully!");

    } catch (error) {
        console.error("Error sending Excel:", error);
        toast.error("Error sending Excel file. Please try again.");
    }
};
